import { atom } from "recoil";
import { Invitation } from "../model";

export const invitationsState = atom<Invitation[]>({
  key: 'invitationsState',
  default: [],
});